"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67246],{

/***/ 631161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ BuildPcDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(123579);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(804393);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(562194);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(924780);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(528938);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(327601);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(124902);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(235904);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(534090);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(677111);
/* harmony import */ var _repositories__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(497278);
/* harmony import */ var _components_BuildPcModal__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(511951);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(881633);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(700074);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88837);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(420577);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(955006);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(319326);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(411213);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(679376);
/* harmony import */ var _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(68098);
/* harmony import */ var constants_buildpc__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(360339);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 80px;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: white;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
















const Spacer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject());
const StyledBuildPcItem = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .BuildPcItem */ .y)(_templateObject1());
const StyledBuildPcSummary = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject2());
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W)(_templateObject3());
const StyledMiniSlides = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .MiniSlides */ .H)(_templateObject4());
const PageTitle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h1(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const StyledDescription = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .Description */ .d)(_templateObject6());
const BuildPcDesktop = ()=>{
    const { convertNewProductCard  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useNewProductCard */ .A)({
        disableHandlerUnder18: true
    });
    const { onAddMultipleItems , loading: cartLoading  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_10__/* .useCartV2 */ .T6)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { 0: category , 1: setCategory  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const dispatch = (0,_contexts__WEBPACK_IMPORTED_MODULE_11__/* .useBuildPcDispatch */ .bC)();
    const state = (0,_contexts__WEBPACK_IMPORTED_MODULE_11__/* .useBuildPcState */ .Gh)();
    const { 0: allSkus , 1: setAllSkus  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { banners: topSlider , loading: loadingTopSlider  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useBanners */ .U)("pv-buildpc-slider-banner");
    const { banners: staticBanners  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useBanners */ .U)("pv-buildpc-static-banner");
    const buildPcLocalVariable = "buildPc2";
    const getLocalConfigs = ()=>{
        let result = [
            {},
            {},
            {}
        ];
        const lsBuildPcLocalConfigs =  true ? localStorage.getItem(buildPcLocalVariable) : 0;
        if (!!lsBuildPcLocalConfigs && (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs).length > 0) {
            result = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs);
        }
        return result;
    };
    const getAllConfigSkus = (configurations)=>{
        const skus = [];
        configurations.forEach((config)=>{
            var ref;
            (ref = Object.keys(config)) === null || ref === void 0 ? void 0 : ref.forEach((key)=>{
                var ref, ref1;
                if (!skus.includes((ref = config[key].product) === null || ref === void 0 ? void 0 : ref.sku)) skus.push((ref1 = config[key].product) === null || ref1 === void 0 ? void 0 : ref1.sku);
            });
        });
        return skus;
    };
    const { result , isLoading  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useSkus */ .TA)(allSkus.length ? allSkus : []);
    const convertedProductsData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return result === null || result === void 0 ? void 0 : result.products.map(convertNewProductCard);
    }, [
        result
    ]);
    const changeConfiguration = (index)=>{
        dispatch({
            type: "CHANGE_CONFIGURATION",
            payload: index
        });
    };
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(state.currentConfiguration);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                const key = configKeys[i];
                const product = convertedProductsData.find((el)=>el.sku === state.currentConfiguration[key].product.sku);
                const quantity = state.currentConfiguration[key].quantity;
                if (product) products.push({
                    sku: product.sku,
                    quantity,
                    promotionId: product.selectPromotionId
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log(error);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch({
            type: "SET_CONFIGURATIONS",
            payload: getLocalConfigs()
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        localStorage.setItem(buildPcLocalVariable, JSON.stringify(state.configurations));
        setAllSkus(getAllConfigSkus(state.configurations));
    }, [
        state.currentConfiguration
    ]);
    const isEmpty = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return Object.keys(state.currentConfiguration).length === 0;
    }, [
        state.currentConfiguration
    ]);
    const total = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (isEmpty) return 0;
        return Object.keys(state.currentConfiguration).reduce((total, current)=>{
            var ref, ref1, ref2, ref3;
            const line = state.currentConfiguration[current];
            const price = (line === null || line === void 0 ? void 0 : (ref = line.product) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || (line === null || line === void 0 ? void 0 : (ref2 = line.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
            return total + price * line.quantity;
        }, 0);
    }, [
        state.currentConfiguration,
        isEmpty
    ]);
    const breadCrumbs = [
        {
            link: "/",
            name: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Trang chủ")
        },
        {
            disabled: true,
            link: "#",
            name: "Build Pc"
        }, 
    ];
    // Specific flow for PV: https://jira.teko.vn/browse/UX4BUYER-6625
    const initialSocketOption = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const getInitialFilter = (target, current)=>{
            var ref;
            if ((category === null || category === void 0 ? void 0 : category.id) === target && ((ref = state.currentConfiguration[current]) === null || ref === void 0 ? void 0 : ref.quantity) > 0) {
                var ref1;
                const product = convertedProductsData.find((p)=>p.sku === state.currentConfiguration[current].product.sku);
                const socketOptionValue = product === null || product === void 0 ? void 0 : (ref1 = product.attributeGroups) === null || ref1 === void 0 ? void 0 : ref1.find((att)=>constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .SOCKET_ATTRIBUTE_GROUPS_ID.includes */ .AT.includes(att.id));
                if (!!socketOptionValue) {
                    switch(target){
                        case constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .CPU_CATEGORY_ID */ .rY:
                            var ref2;
                            return {
                                filterCode: constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .CPU_SOCKET_ATTRIBUTE_CODE */ .Bf,
                                filterName: socketOptionValue.name,
                                optionName: (ref2 = socketOptionValue.value) === null || ref2 === void 0 ? void 0 : ref2.trim()
                            };
                        case constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .MAIN_BOARD_CATEGORY_ID */ .Gp:
                            var ref3;
                            return {
                                filterCode: constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .MAIN_BOARD_SOCKET_ATTRIBUTE_CODE */ .t5,
                                filterName: socketOptionValue.name,
                                optionName: (ref3 = socketOptionValue.value) === null || ref3 === void 0 ? void 0 : ref3.trim()
                            };
                    }
                }
            }
            return null;
        };
        return getInitialFilter(constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .CPU_CATEGORY_ID */ .rY, constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .MAIN_BOARD_CATEGORY_ID */ .Gp) || getInitialFilter(constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .MAIN_BOARD_CATEGORY_ID */ .Gp, constants_buildpc__WEBPACK_IMPORTED_MODULE_16__/* .CPU_CATEGORY_ID */ .rY) || {};
    }, [
        JSON.stringify(state.currentConfiguration),
        category
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_17__/* .Loading */ .g, {
                isLoading: isLoading || cartLoading,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__/* .Row */ .X, {
                            justify: "start",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__/* .Breadcrumbs */ .O, {
                                breadcrumbs: breadCrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledMiniSlides, {
                            height: 200,
                            width: 1200,
                            isLoading: loadingTopSlider,
                            banners: topSlider || []
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                            children: "Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__/* .Row */ .X, {
                            marginTop: "s16",
                            justify: "space-between",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .Col */ .JX, {
                                span: 8.5,
                                paddingLeft: "s8",
                                paddingRight: "s8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__/* .BuildPcTabs */ .N, {
                                    onClickTab: (index)=>changeConfiguration(index)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__/* .Row */ .X, {
                            marginTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .Col */ .JX, {
                                    span: 8.5,
                                    paddingLeft: "s8",
                                    paddingRight: "s8",
                                    children: _repositories__WEBPACK_IMPORTED_MODULE_22__/* .CategoryRepository.all */ .M.all().map((category)=>{
                                        const selectedHardware = state.currentConfiguration[category.id];
                                        let product = null;
                                        if (selectedHardware) {
                                            product = convertedProductsData.find((product)=>product.sku === selectedHardware.product.sku) || selectedHardware.product;
                                        }
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBuildPcItem, {
                                            title: category.name,
                                            icon: category.icon,
                                            onIncrease: ()=>dispatch({
                                                    type: "ADD_HARDWARE",
                                                    payload: {
                                                        categoryId: category.id,
                                                        product: selectedHardware.product
                                                    }
                                                }),
                                            onDecrease: ()=>dispatch({
                                                    type: "REDUCE_HARDWARE_QUANTITY",
                                                    payload: {
                                                        categoryId: category.id
                                                    }
                                                }),
                                            setQuantity: (value)=>dispatch({
                                                    type: "SET_HARDWARE_QUANTITY",
                                                    payload: {
                                                        categoryId: category.id,
                                                        quantity: value
                                                    }
                                                }),
                                            product: product ? product : undefined,
                                            actionText: product ? (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Sửa") : (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Chọn"),
                                            onClick: ()=>setCategory(category),
                                            quantity: selectedHardware ? selectedHardware.quantity : undefined
                                        }, category.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_20__/* .Col */ .JX, {
                                    span: 3.5,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBuildPcSummary, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_23__/* .BuildPcSummary */ .b, {
                                                total: total,
                                                selectedCount: Object.keys(state.currentConfiguration).length,
                                                onAddToCart: onAddConfigurationToCart,
                                                onBuy: ()=>{
                                                    onAddConfigurationToCart().then(()=>router.push("/cart"));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_24__/* .Card */ .Z, {
                                                marginTop: "s16",
                                                padding: "s16",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__/* .CustomLink */ .x, {
                                                    targetType: "_blank",
                                                    targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__/* .Button */ .z, {
                                                        variant: "primary",
                                                        block: true,
                                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Nhận tư vấn từ chuy\xean gia")
                                                    })
                                                })
                                            }),
                                            staticBanners && !!staticBanners[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spacer, {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__/* .CustomLink */ .x, {
                                                        targetPath: staticBanners[0].targetPath,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_27__/* .LazyImage */ .w, {
                                                            hover: "zoom",
                                                            borderRadius: 8,
                                                            src: staticBanners[0].image
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_28__/* .pageDescriptionContent */ .E && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDescription, {
                                className: "ck-content",
                                content: _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_28__/* .pageDescriptionContent */ .E,
                                maxHeight: 760,
                                showMoreLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Xem th\xeam nội dung"),
                                showLessLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Thu gọn nội dung")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__/* .Modal */ .u, {
                            width: "748px",
                            visible: !!category,
                            onClose: ()=>setCategory(null),
                            footer: false,
                            children: category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BuildPcModal__WEBPACK_IMPORTED_MODULE_30__/* .BuildPcModal */ .j, {
                                onHide: ()=>setCategory(null),
                                category: category,
                                initialSocketOption: initialSocketOption
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_31__/* .PrintBuildPc */ .r, {
                total: total,
                buildpc: state.currentConfiguration
            })
        ]
    });
};


/***/ }),

/***/ 617958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BuildPcMobile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(804393);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(432283);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(924780);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(528938);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(327601);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(124902);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(235904);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(534090);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(677111);
/* harmony import */ var _repositories__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(497278);
/* harmony import */ var _components_BuildPcModal__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(511951);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(881633);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(700074);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88837);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(420577);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(955006);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(319326);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(848884);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(679376);
/* harmony import */ var components_Layout_MobileLayout__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(303094);
/* harmony import */ var helpers_terra__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(632843);
/* harmony import */ var _BuildPcMobileItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(481689);
/* harmony import */ var _BuildPcMobileTabs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(704251);
/* harmony import */ var _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(68098);
/* harmony import */ var constants_buildpc__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(360339);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  .teko-modal-content {\n    height: 100%;\n    border-radius: 0;\n    padding: 16px;\n  }\n  .teko-modal-body {\n    height: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1rem;\n  font-weight: 700;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: white;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





















const Spacer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject());
const StyledBuildPcItem = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_BuildPcMobileItem__WEBPACK_IMPORTED_MODULE_5__/* .BuildPcMobileItem */ .g)(_templateObject1());
const StyledBuildPcSummary = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject2());
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W)(_templateObject3());
const StyledMiniSlides = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .MiniSlides */ .H)(_templateObject4());
const StyledModal = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Modal */ .u)(_templateObject5());
const PageTitle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h1(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const SiteDescription = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .Description */ .d)(_templateObject7());
const BuildPcMobile = ()=>{
    const { convertNewProductCard  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useNewProductCard */ .A)({
        disableHandlerUnder18: true
    });
    const { onAddMultipleItems , loading: cartLoading  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_11__/* .useCartV2 */ .T6)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { 0: category , 1: setCategory  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const dispatch = (0,_contexts__WEBPACK_IMPORTED_MODULE_12__/* .useBuildPcDispatch */ .bC)();
    const state = (0,_contexts__WEBPACK_IMPORTED_MODULE_12__/* .useBuildPcState */ .Gh)();
    const { 0: allSkus , 1: setAllSkus  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { banners: topSlider , loading: loadingTopSlider  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useBanners */ .U)("pv-buildpc-slider-banner");
    const { banners: staticBanners  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useBanners */ .U)("pv-buildpc-static-banner");
    const buildPcLocalVariable = "buildPc2";
    const getLocalConfigs = ()=>{
        let result = [
            {},
            {},
            {}
        ];
        const lsBuildPcLocalConfigs =  true ? localStorage.getItem(buildPcLocalVariable) : 0;
        if (!!lsBuildPcLocalConfigs && (0,_teko_utils__WEBPACK_IMPORTED_MODULE_14__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs).length > 0) {
            result = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_14__/* .parseJsonStringSafely */ .O)(lsBuildPcLocalConfigs);
        }
        return result;
    };
    const getAllConfigSkus = (configurations)=>{
        const skus = [];
        configurations.forEach((config)=>{
            var ref;
            (ref = Object.keys(config)) === null || ref === void 0 ? void 0 : ref.forEach((key)=>{
                var ref, ref1;
                if (!skus.includes((ref = config[key].product) === null || ref === void 0 ? void 0 : ref.sku)) skus.push((ref1 = config[key].product) === null || ref1 === void 0 ? void 0 : ref1.sku);
            });
        });
        return skus;
    };
    const { result , isLoading  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_15__/* .useSkus */ .TA)(allSkus.length ? allSkus : []);
    const convertedProductsData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return result === null || result === void 0 ? void 0 : result.products.map(convertNewProductCard);
    }, [
        result
    ]);
    const changeConfiguration = (index)=>{
        dispatch({
            type: "CHANGE_CONFIGURATION",
            payload: index
        });
    };
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(state.currentConfiguration);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                const key = configKeys[i];
                const product = convertedProductsData.find((el)=>el.sku === state.currentConfiguration[key].product.sku);
                const quantity = state.currentConfiguration[key].quantity;
                if (product) products.push({
                    sku: product.sku,
                    quantity,
                    promotionId: product.selectPromotionId
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .k.log(error);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch({
            type: "SET_CONFIGURATIONS",
            payload: getLocalConfigs()
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        localStorage.setItem(buildPcLocalVariable, JSON.stringify(state.configurations));
        setAllSkus(getAllConfigSkus(state.configurations));
    }, [
        state.currentConfiguration
    ]);
    const isEmpty = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return Object.keys(state.currentConfiguration).length === 0;
    }, [
        state.currentConfiguration
    ]);
    const total = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (isEmpty) return 0;
        return Object.keys(state.currentConfiguration).reduce((total, current)=>{
            var ref, ref1, ref2, ref3;
            const line = state.currentConfiguration[current];
            const price = (line === null || line === void 0 ? void 0 : (ref = line.product) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || (line === null || line === void 0 ? void 0 : (ref2 = line.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.price) || 0;
            return total + price * line.quantity;
        }, 0);
    }, [
        state.currentConfiguration,
        isEmpty
    ]);
    const breadCrumbs = [
        {
            link: "/",
            name: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__/* .HomepageFilled */ .f, {
                size: 24,
                color: "placeholder"
            })
        },
        {
            disabled: true,
            link: "#",
            name: "Build PC"
        }, 
    ];
    // Specific flow for PV: https://jira.teko.vn/browse/UX4BUYER-6625
    // the same function with desktop ==> todo: refactor desktop and mobile, should move state to buildPcContext
    const initialSocketOption = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const getInitialFilter = (target, current)=>{
            var ref;
            if ((category === null || category === void 0 ? void 0 : category.id) === target && ((ref = state.currentConfiguration[current]) === null || ref === void 0 ? void 0 : ref.quantity) > 0) {
                var ref1;
                const product = convertedProductsData.find((p)=>p.sku === state.currentConfiguration[current].product.sku);
                const socketOptionValue = product === null || product === void 0 ? void 0 : (ref1 = product.attributeGroups) === null || ref1 === void 0 ? void 0 : ref1.find((att)=>constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .SOCKET_ATTRIBUTE_GROUPS_ID.includes */ .AT.includes(att.id));
                if (!!socketOptionValue) {
                    switch(target){
                        case constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .CPU_CATEGORY_ID */ .rY:
                            var ref2;
                            return {
                                filterCode: constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .CPU_SOCKET_ATTRIBUTE_CODE */ .Bf,
                                filterName: socketOptionValue.name,
                                optionName: (ref2 = socketOptionValue.value) === null || ref2 === void 0 ? void 0 : ref2.trim()
                            };
                        case constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .MAIN_BOARD_CATEGORY_ID */ .Gp:
                            var ref3;
                            return {
                                filterCode: constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .MAIN_BOARD_SOCKET_ATTRIBUTE_CODE */ .t5,
                                filterName: socketOptionValue.name,
                                optionName: (ref3 = socketOptionValue.value) === null || ref3 === void 0 ? void 0 : ref3.trim()
                            };
                    }
                }
            }
            return null;
        };
        return getInitialFilter(constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .CPU_CATEGORY_ID */ .rY, constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .MAIN_BOARD_CATEGORY_ID */ .Gp) || getInitialFilter(constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .MAIN_BOARD_CATEGORY_ID */ .Gp, constants_buildpc__WEBPACK_IMPORTED_MODULE_17__/* .CPU_CATEGORY_ID */ .rY) || {};
    }, [
        JSON.stringify(state.currentConfiguration),
        category
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_18__/* .Loading */ .g, {
                isLoading: isLoading || cartLoading,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_MobileLayout__WEBPACK_IMPORTED_MODULE_19__.MobileLayout, {
                            navbar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_20__/* .DetailNavBar */ .W, {
                                goBack: ()=>{
                                    helpers_terra__WEBPACK_IMPORTED_MODULE_21__/* ["default"].handleBackOr */ .Z.handleBackOr(()=>{
                                        router.back();
                                    });
                                }
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    padding: "0 1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Row */ .X, {
                                        justify: "start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_23__/* .Breadcrumbs */ .O, {
                                            breadcrumbs: breadCrumbs,
                                            isMobile: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledMiniSlides, {
                                        height: 200,
                                        width: 1200,
                                        isLoading: loadingTopSlider,
                                        banners: topSlider || []
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                                        children: "Build PC - X\xe2y dựng cấu h\xecnh m\xe1y t\xednh"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Row */ .X, {
                                        marginTop: "s16",
                                        justify: "space-between",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BuildPcMobileTabs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                            onClickTab: (index)=>changeConfiguration(index)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Row */ .X, {
                                        marginTop: "s16",
                                        children: _repositories__WEBPACK_IMPORTED_MODULE_25__/* .CategoryRepository.all */ .M.all().map((category)=>{
                                            const selectedHardware = state.currentConfiguration[category.id];
                                            let product = null;
                                            if (selectedHardware) {
                                                product = convertedProductsData.find((product)=>product.sku === selectedHardware.product.sku) || selectedHardware.product;
                                            }
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBuildPcItem, {
                                                title: category.name,
                                                icon: category.icon,
                                                onIncrease: ()=>dispatch({
                                                        type: "ADD_HARDWARE",
                                                        payload: {
                                                            categoryId: category.id,
                                                            product: selectedHardware.product
                                                        }
                                                    }),
                                                onDecrease: ()=>dispatch({
                                                        type: "REDUCE_HARDWARE_QUANTITY",
                                                        payload: {
                                                            categoryId: category.id
                                                        }
                                                    }),
                                                setQuantity: (value)=>dispatch({
                                                        type: "SET_HARDWARE_QUANTITY",
                                                        payload: {
                                                            categoryId: category.id,
                                                            quantity: value
                                                        }
                                                    }),
                                                product: product ? product : undefined,
                                                actionText: product ? (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Sửa") : (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Chọn"),
                                                onClick: ()=>setCategory(category),
                                                quantity: selectedHardware ? selectedHardware.quantity : undefined
                                            }, category.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Row */ .X, {
                                        marginTop: "s8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBuildPcSummary, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_27__/* .BuildPcSummary */ .b, {
                                                    total: total,
                                                    selectedCount: Object.keys(state.currentConfiguration).length,
                                                    onAddToCart: onAddConfigurationToCart,
                                                    onBuy: ()=>{
                                                        onAddConfigurationToCart().then(()=>router.push("/cart"));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_28__/* .Card */ .Z, {
                                                    marginTop: "s16",
                                                    padding: "s16",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__/* .Button */ .z, {
                                                            variant: "primary",
                                                            block: true,
                                                            onClick: ()=>window.print(),
                                                            marginBottom: "s16",
                                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Tải file PDF cấu h\xecnh")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_30__/* .CustomLink */ .x, {
                                                            targetType: "_blank",
                                                            targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_29__/* .Button */ .z, {
                                                                variant: "primary",
                                                                block: true,
                                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Nhận tư vấn từ chuy\xean gia")
                                                            })
                                                        })
                                                    ]
                                                }),
                                                staticBanners && !!staticBanners[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spacer, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_30__/* .CustomLink */ .x, {
                                                            targetPath: "",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_31__/* .LazyImage */ .w, {
                                                                hover: "zoom",
                                                                borderRadius: 8,
                                                                src: staticBanners[0].image
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_32__/* .pageDescriptionContent */ .E && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .Row */ .X, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SiteDescription, {
                                            className: "ck-content",
                                            content: _pageDescriptionContent__WEBPACK_IMPORTED_MODULE_32__/* .pageDescriptionContent */ .E,
                                            maxHeight: 445,
                                            showMoreLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Xem th\xeam nội dung"),
                                            showLessLabel: (0,i18n__WEBPACK_IMPORTED_MODULE_26__.t)("Thu gọn nội dung")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModal, {
                            width: "748px",
                            maxWidth: "100%",
                            visible: !!category,
                            onClose: ()=>setCategory(null),
                            footer: false,
                            children: category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BuildPcModal__WEBPACK_IMPORTED_MODULE_33__/* .BuildPcModal */ .j, {
                                onHide: ()=>setCategory(null),
                                category: category,
                                initialSocketOption: initialSocketOption
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_34__/* .PrintBuildPc */ .r, {
                total: total,
                buildpc: state.currentConfiguration
            })
        ]
    });
};


/***/ }),

/***/ 481689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BuildPcMobileItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(319326);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(670894);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(650983);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(770024);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811850);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73586);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(260613);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  color: unset;\n  text-decoration: unset;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n  transition: box-shadow 0.2s ease-in-out;\n  &:hover {\n    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  font-weight: 500;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  color: #757575;\n  font-size: 0.8125rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  height: 32px;\n  width: 60px;\n  padding: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






const Anchor = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].a(_templateObject());
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Card */ .Z)(_templateObject1());
const StyledPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .ProductPrice */ .j)(_templateObject2());
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject3());
const StyledProductGifts = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .ProductGifts */ .W)(_templateObject4());
const SKU = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span(_templateObject5());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z)(_templateObject6());
const StyledButtonDelete = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT)((param)=>{
    let { theme  } = param;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n");
});
const BuildPcMobileItem = (_param)=>{
    var { title , product , onIncrease , onDecrease , onClick , actionText , quantity , setQuantity , showDeleteButton , onDelete  } = _param, props = _objectWithoutProperties(_param, [
        "title",
        "product",
        "onIncrease",
        "onDecrease",
        "onClick",
        "actionText",
        "quantity",
        "setQuantity",
        "showDeleteButton",
        "onDelete"
    ]);
    var ref, ref1;
    const disableButton = ()=>{
        var ref;
        if (product && !(product === null || product === void 0 ? void 0 : (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice)) return true;
    };
    const selectHardwareButton = product && product.showContact ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
        block: true,
        variant: "primary",
        tag: "a",
        href: "https://m.me/phongvuvietnam",
        target: "_blank",
        children: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Li\xean hệ")
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
        disabled: disableButton(),
        onClick: onClick,
        variant: "primary",
        children: actionText
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCard, _objectSpreadProps(_objectSpread({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                align: "middle",
                children: title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                            span: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                justify: "start",
                                marginBottom: product ? "s16" : undefined,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                    children: title
                                })
                            })
                        }),
                        !product && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                            span: 8,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                justify: "end",
                                children: selectHardwareButton
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                children: product && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                    span: 12,
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .LazyImage */ .w, {
                                width: 65,
                                height: 65,
                                src: product === null || product === void 0 ? void 0 : product.imageUrl,
                                onClick: ()=>{
                                    if (!product) onClick === null || onClick === void 0 ? void 0 : onClick();
                                },
                                border: true,
                                borderRadius: 8,
                                contain: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                                span: 12,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                                        // @ts-ignore
                                        href: (ref = product.link) === null || ref === void 0 ? void 0 : (ref1 = ref.as) === null || ref1 === void 0 ? void 0 : ref1.pathname,
                                        rel: "noreferrer noopener",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__/* .ProductName */ .r, {
                                            name: product.name || (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("T\xean sản phẩm đang được cập nhật")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SKU, {
                                            children: [
                                                "SKU: ",
                                                product.sku
                                            ]
                                        })
                                    }),
                                    product.gifts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledProductGifts, {
                                            label: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tặng ngay"),
                                            images: product.gifts.images
                                        })
                                    }),
                                    product.price && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPrice, {
                                            price: product.price.latestPrice,
                                            discount: product.price.discountPercent,
                                            listedPrice: product.price.supplierRetailPrice
                                        })
                                    }),
                                    quantity && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                        marginTop: "s8",
                                        align: "middle",
                                        justify: "start",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__/* .BuildPcNumberStepper */ .F, {
                                                        onIncrease: onIncrease,
                                                        onDecrease: onDecrease,
                                                        setValue: setQuantity,
                                                        value: quantity
                                                    })
                                                }),
                                                showDeleteButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                                                    justify: "center",
                                                    align: "middle",
                                                    marginTop: "s12",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButtonDelete, {
                                                        level: 1,
                                                        onClick: onDelete,
                                                        children: (0,_i18n__WEBPACK_IMPORTED_MODULE_8__.t)("X\xf3a")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                            justify: "start",
                            children: selectHardwareButton
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 704251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(802705);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b)((param)=>{
    let { direction  } = param;
    return "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 0.5rem;\n  a {\n    text-decoration: unset;\n  }\n  direction: ".concat(direction, ";\n");
});
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)((param)=>{
    let { isActive  } = param;
    return "\n    ".concat(!isActive ? "background-color: #E0E0E0" : "", ";\n    direction: ltr;\n  ");
});
const BuildPcMobileTabs = (_param)=>{
    var { onClickTab , onResetConfig , lsActiveTab  } = _param, props = _objectWithoutProperties(_param, [
        "onClickTab",
        "onResetConfig",
        "lsActiveTab"
    ]);
    const { 0: activeTab , 1: setActiveTab  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(lsActiveTab || 0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, _objectSpreadProps(_objectSpread({
                marginBottom: "s8"
            }, props), {
                children: [
                    0,
                    1,
                    2
                ].map((tab)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                        variant: tab === activeTab ? "primary" : "default",
                        isActive: tab === activeTab,
                        onClick: ()=>{
                            setActiveTab(tab);
                            onClickTab && onClickTab(tab);
                        },
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Cấu h\xecnh {{number}}", {
                            number: tab + 1
                        })
                    }, tab))
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
                direction: "rtl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButton, {
                    isActive: true,
                    variant: "primary",
                    onClick: onResetConfig,
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Tạo lại"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .RefreshOutlined */ .y, {
                            color: "white",
                            size: 16,
                            style: {
                                marginLeft: "0.5rem"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BuildPcMobileTabs);


/***/ })

}]);